import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './../AuthContext'; // Import useAuth hook
import { apiDoLogin } from './../process/api';
import PasswordStrengthBar from 'react-password-strength-bar';
import {getUserID} from "../utils";
import { proxy } from '../process/api';

const Login = () => {
    const [username, setUsername] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [password, setPassword] = useState('');
    const [oldPassword, setoldPassword] = useState('');
    const navigate = useNavigate();
    const { login, isLoggedIn } = useAuth();
    const [isLoginError, setLoginError] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);

    const [loginErrorMessage, setLoginErrorMsg] = useState('');
    const currentToken = localStorage.getItem('token');
    const [isValid, setIsValid] = useState(true);


    const handleChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        validatePassword(newPassword);
    };

    const validatePassword = (password) => {
       return true;
        const minLength = password.length >= 8;
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        
        setIsValid(minLength && hasNumber && hasSpecialChar);
      };



    const handleSubmit = async (event) => {


        console.log("ak")
        if(password != confPassword){
            alert("Password and Confirm password should be same.");
            return;
        }
        if(password == ""){
            alert("Password cannot be empty.");
            return;
        }
        if(password == "123" || password == "1234" ){
            alert("This password is not allowed.");
            return;
        }
        
        event.preventDefault();

        var btnLogin = document.getElementById('btnLogin');
        btnLogin.innerText = 'Validating...';
       
        const payload = {
            "user_id":getUserID(currentToken),
    "old_password":oldPassword,
    "new_password":confPassword
        }
        const apiResponse =  await proxy(`/auth/changePassword`, payload, "post");
      
       
        if(apiResponse == "Password Changes successfully"){
            setLoginErrorMsg(apiResponse);
            setisSuccess(true);
    
            setConfPassword('');
            setPassword('');
            setoldPassword('');
            var btnLogin = document.getElementById('btnLogin');
            btnLogin.innerText = 'Change Password';
            setLoginErrorMsg(apiResponse + ". Please login to portal");
            setTimeout(() => {
                    navigate("/login");
            }, 5000);
        }else{
            setLoginErrorMsg(apiResponse);
            setLoginError(true);
    
            setConfPassword('');
            setPassword('');
            setoldPassword('');
            var btnLogin = document.getElementById('btnLogin');
            btnLogin.innerText = 'Change Password';
        }

    };

    return (
        <div style={{background:"url(/../../images/bg.jpg) ", backgroundPosition:"center center", backgroundSize:"cover"}}>
        <div className="container">
            <div className='custom-login-container'>
            <div className='row ' style={{flexDirection:"row-reverse", justifyContent:"center"}}>
                    {/* <div className='col-md-7'>

                        <img src="../../images/login-left.png" alt="LEFT PROMO IMAGE" className='img-responsive' />
                    </div> */}

                    <div className='col-md-5 col-xs-12'>

                        <div className='login-outer-wrapper'>
                        <div className='login-wrapper'>
                        <img src="../../images/logo.png" alt='LOGO' className='brand-image' />
                        <img src="/../../images/dart-logo.png" alt='DART' style={{maxWidth:"160px", margin:"0px auto 20px ", display:"block"}} />
                           
                                <h2>Change Password</h2>

                                <p>You are required to change password before accessing the portal.</p>
                               


                                    {isLoginError && <div className='alert alert-info'>{loginErrorMessage}</div>}
                                    {isSuccess && <div className='alert alert-success'>{loginErrorMessage} <a href='/login' style={{color:"#333", textDecoration:"underline"}}>LOGIN HERE</a></div>}
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Old Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="oldPass"
                                            value={oldPassword}
                                            onChange={(e)=>setoldPassword(e.target.value)}
                                           
                                        />
                                    </div>


                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label">New Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="username"
                                            value={password}
                                            onChange={(e) => handleChange(e)}
                                            style={{ borderColor: isValid ? 'initial' : 'red',outline:isValid ? 'initial' : 'red' }}
                                        />
                                        
                                         <PasswordStrengthBar password={password} minLength={8} />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Confirm Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="confpassword"
                                            value={confPassword}
                                            onChange={(e)=>setConfPassword(e.target.value)}
                                           
                                        />
                                    </div>
                                    <button type="submit" onClick={handleSubmit} className="btn btn-primary btn-block btn-md" id='btnLogin'>Change Password</button>
                               
                            </div>
                        </div>

                    </div>
                </div>  </div>
        </div>
        </div>
    );
};

export default Login;
